import md5 from "js-md5";
import * as dayjs from "dayjs";
import axios from "axios";
import store from "@/store/index";

/**
 * 上传文件或blob
 * @return {Promise<{name, url}>}
 * @param obj
 */
export const uploadFileBlob = async ({
  target,
  path = "",
  maxSize = 0, // 单位M
  allowTypeList = [],
} = {}) => {
  const { bucket_name, endpoint, uptoken } = store.getters.obsUploadData;
  const { access_key_id: AccessKeyId, signature, domain, policy } = uptoken;
  const type = Object.prototype.toString
    .call(target)
    .slice(8, -1)
    .toLowerCase();
  return new Promise(async (resolve, reject) => {
    if (!["file", "blob"].includes(type)) {
      reject(new TypeError(`不支持${type}类型的文件上传！`));
      return;
    }
    const blob = type === "file" ? await transformFileToBlob(target) : target;
    if (!checkBlobSize(blob, maxSize)) {
      reject(new RangeError(`大小超出${maxSize}M限制！`));
      return;
    }
    if (!checkBlobType(blob, allowTypeList)) {
      reject(
        new TypeError(
          `上传文件类型:${blob.type}, 不属于${allowTypeList}中的任意一种！`,
        ),
      );
      return;
    }
    const random = md5(`${blob.type}${Date.now()}`);
    const customPath = path.replace(/^\/*|\/*$/g, "")
      ? path.replace(/^\/*|\/*$/g, "") + "/"
      : "";
    const suffix = blob.type.split("/").splice(-1);
    if (!suffix) {
      reject(new TypeError(`${target}类型未知，请主动明确Blob的类型`));
      return;
    }
    const key = `obs/${customPath}${dayjs().format(
      "YYYY/MM/DD",
    )}/${random}.${suffix}`;
    const formData = new FormData();
    formData.append("policy", policy);
    formData.append("AccessKeyId", AccessKeyId);
    formData.append("signature", signature);
    formData.append("domain", domain);
    formData.append("success_action_status", "201");
    formData.append("key", key);
    formData.append("file", blob);
    await axios
      .request({
        url: `https://${bucket_name}.${endpoint}/`,
        method: "post",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: false,
      })
      .then(res => {
        resolve({ name: key, url: `${domain}${key}` });
      })
      .catch(e => {
        reject(e);
      });
  });
};

/**
 * 判断Blob大小
 * @param {Blob} blob
 * @param {number} maxSize 单位M
 * @return {boolean}
 */
export const checkBlobSize = (blob, maxSize = 0) => {
  const type = Object.prototype.toString
    .call(blob)
    .slice(8, -1)
    .toLowerCase();
  return !maxSize || type !== "blob" || blob.size <= maxSize * 1024 * 1024;
};

/**
 * 判断Blob类型
 * @param {Blob} blob
 * @param {array} allowTypeList
 * @return {boolean|boolean}
 */
export const checkBlobType = (blob, allowTypeList = []) => {
  const type = Object.prototype.toString
    .call(blob)
    .slice(8, -1)
    .toLowerCase();
  return (
    !allowTypeList?.length ||
    type !== "blob" ||
    allowTypeList.some(item => blob.type.indexOf(item) !== -1)
  );
};

/**
 * File转Blob
 * @param file
 * @return {Promise<Blob>}
 */
export const transformFileToBlob = file => {
  return new Promise((resolve, reject) => {
    const type = Object.prototype.toString
      .call(file)
      .slice(8, -1)
      .toLowerCase();
    if (type !== "file") {
      reject(new TypeError(`非File类型不支持转Blob，请检查${file}`));
      return;
    }
    let blob = null;
    let reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = async e => {
      if (typeof e.target.result === "object") {
        blob = new Blob([e.target.result], { type: file.type });
      } else {
        blob = e.target.result;
      }
      resolve(blob);
    };
  });
};

/**
 * 下载华为云文件
 */
export const downloadObsFile = async url => {
  const { uptoken } = store.getters.obsUploadData;
  const { domain } = uptoken;
  window.open(`${domain}${url}`);
};



// WEBPACK FOOTER //
// ./src/tool/upload.js